import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BenefitsResultView, benefitsResultView } from './benefits-check-result-view';
import { ManualBenefitsCheckResponse } from './manual-benefits-check.model';

/** Compact answer to "Run benefits check". Plain words only; it logs nothing. */
@Component({
  selector: 'app-benefits-check-result-dialog',
  templateUrl: './benefits-check-result-dialog.component.html',
  styleUrls: ['./benefits-check-result-dialog.component.scss'],
})
export class BenefitsCheckResultDialogComponent {
  readonly view: BenefitsResultView;

  constructor(@Inject(MAT_DIALOG_DATA) data: ManualBenefitsCheckResponse) {
    this.view = benefitsResultView(data);
  }
}
